/* ══════════════════════════════════════════════════════════════════════════════════════════════════
   MNL — AUDIT DE DOSE DES 14 PAGES FORMULE (19ᵉ PORTE). V1260 — 06/08/2026.
   ══════════════════════════════════════════════════════════════════════════════════════════════════

   ── CE QU'IL EST, ET SURTOUT CE QU'IL N'EST PAS ───────────────────────────────────────────────────
   Ce fichier n'est PAS la conversion de ces pages. La conversion, elle, est DÉJÀ FAITE : elle est
   cuite dans le Liquid par le module lui-même (voir l'en-tête V1260 de sections/mnl-formula-buy.liquid
   et le vérificateur verif-porte19.mjs). Ici on ne fait que RELIRE ce qui est cuit, et le corriger si
   le module déployé n'est pas d'accord.

   ── POURQUOI LA CONVERSION NE PEUT PAS VIVRE ICI ──────────────────────────────────────────────────
   Le <form action="/cart/add"> de ces pages est NATIF, délibérément : ces quatorze pages reçoivent le
   trafic publicitaire, donc les webviews TikTok et Instagram, c'est-à-dire précisément les navigateurs
   où le JavaScript casse. Une page qui ne saurait envoyer la bonne dose QUE si un script a tourné
   enverrait la mauvaise dose à chaque fois que le script ne tourne pas — et personne ne le verrait,
   puisque la vente, elle, passerait quand même. La valeur juste doit donc être DANS LE HTML avant
   qu'une ligne de JavaScript ne s'exécute. Ce fichier est une SECONDE garantie, jamais la première.

   ── POURQUOI IL EXISTE QUAND MÊME ─────────────────────────────────────────────────────────────────
   Le cas qu'il couvre est réel et il a déjà eu lieu dans ce dépôt : le module est redéployé (une
   grille baisse) et le Liquid n'est pas recuit. Le vérificateur de dépôt crierait — mais seulement si
   quelqu'un le lance. Ici, la page se corrige toute seule, chez le client, sans attendre personne.

   ── LA RÈGLE DE SÛRETÉ, NON NÉGOCIABLE ────────────────────────────────────────────────────────────
       IL NE PEUT QUE CORRIGER UNE VALEUR. IL NE PEUT JAMAIS EMPÊCHER UNE VENTE.
   Aucun preventDefault, aucun disabled, aucun retrait de champ, aucun blocage de bouton. Si le module
   est absent, si l'adaptateur manque, si un libellé ne se résout pas, si quoi que ce soit lève : on ne
   touche à rien et le HTML cuit part tel quel — et il est juste, c'est le banc qui le garantit.
   C'est la même doctrine que assets/mnl-dose-guard.js (« on ne refuse pas la vente ») appliquée à la
   seule surface où refuser la vente n'aurait même pas d'utilité : ici, contrairement au configurateur,
   il n'y a AUCUNE charge utile ancienne à relire — les recettes sont écrites dans le thème.

   ── D'OÙ VIENT LA DOSE QU'IL RECALCULE ────────────────────────────────────────────────────────────
   Du CRAN, jamais des milligrammes. Chaque champ caché porte `data-mnl-cran`, l'indice de la recette
   dans la grille de l'actif ; la dose est MNL_DOSES.doseAt(clé, cran). C'est toute la doctrine du
   dépôt en une ligne : le prix vient de l'indice, donc l'indice est ce qu'on transporte, et la dose
   est ce qu'on en dérive. Un plafond qui baisse ne déplace alors aucun indice — et rien ne peut
   « écrêter », puisque aucun code d'ici ne compare une dose à un plafond.

   TÉMOIN POSITIF : `window.MNL_FBUY_DOSES` porte l'état complet (module vu, signature, lignes lues,
   corrections faites, motifs d'abstention). `MNL_FBUY_DOSES.rapport()` l'imprime.
   ══════════════════════════════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var TAG = '[MNL-P19]';
  var etat = {
    version: 'V1260',
    actif: null,          /* true = l'audit a pu tourner ; false = abstention (jamais un blocage) */
    motifs: [],
    signature: null,
    lignes: 0,
    corrections: [],      /* [{actif, cran, avant, apres}] */
    formulaire: false
  };

  function D() {
    try {
      var d = window.MNL_DOSES;
      return (d && typeof d.doseAt === 'function' && typeof d.indexOf === 'function' && d.CURRENT) ? d : null;
    } catch (_) { return null; }
  }
  function TH() {
    try {
      var t = window.MNL_DOSE_THEME;
      return (t && typeof t.keyFromLabel === 'function' && t.UNIT) ? t : null;
    } catch (_) { return null; }
  }

  /* Écriture de la dose ENVOYÉE — exactement la convention du configurateur (`dose + unité`, unité
     NATIVE de l'actif, point décimal). api/stock.js ne lit que le nombre et applique un facteur fixe
     par clé : écrire « 3000mg » là où la clé est en grammes multiplierait le décrément par mille. */
  function envoi(t, k, v) { return (Math.round(v * 1000) / 1000) + t.UNIT[k]; }

  /* Écriture de la dose AFFICHÉE — convention du fichier Liquid : un actif en mg bascule en grammes
     dès 1000 mg, virgule décimale française. Pure présentation, aucune incidence sur la commande. */
  function affiche(t, k, v) {
    var val = v, u = t.UNIT[k];
    if (u === 'mg' && v >= 1000) { val = v / 1000; u = 'g'; }
    return String(Math.round(val * 1000) / 1000).replace('.', ',') + ' ' + u;
  }

  function auditer(form) {
    var d = D(), t = TH();
    if (!d) { etat.motifs.push('mnl-dose-conversion.js absent — aucune correction tentée, le HTML cuit part tel quel'); etat.actif = false; return; }
    if (!t) { etat.motifs.push('mnl-dose-theme.js absent — aucune correction tentée, le HTML cuit part tel quel'); etat.actif = false; return; }
    etat.signature = d.SIGNATURE || null;
    /* Le module est-il d'accord avec lui-même ? S'il ne l'est pas, ses réponses ne valent pas mieux
       que la valeur cuite : on s'abstient plutôt que de remplacer du juste par du douteux. */
    try {
      var st = d.selfTest();
      if (st && st.ok === false) {
        etat.motifs.push('autotest du module en échec (' + st.echecs.length + '/' + st.total + ') — abstention');
        etat.actif = false; return;
      }
    } catch (_) { etat.motifs.push('autotest du module illisible — abstention'); etat.actif = false; return; }

    var champs = form.querySelectorAll('input[data-mnl-cran][data-mnl-actif]');
    etat.lignes = champs.length;
    for (var i = 0; i < champs.length; i++) {
      try {
        var el = champs[i];
        var nom = el.getAttribute('data-mnl-actif');
        var cran = parseInt(el.getAttribute('data-mnl-cran'), 10);
        var k = t.keyFromLabel(nom);
        if (!k || !d.CURRENT[k]) continue;              /* libellé non résolu : on ne devine pas */
        if (!(cran > 0)) continue;                      /* cran absent ou nul : on ne touche à rien */
        var attendu = d.doseAt(k, cran);                /* LA DOSE VIENT DU CRAN, jamais des mg */
        if (!(attendu > 0)) continue;
        var neuf = envoi(t, k, attendu);
        if (neuf === el.value) continue;                /* déjà juste — le cas normal */
        var avant = el.value;
        el.value = neuf;
        etat.corrections.push({ actif: nom, cle: k, cran: cran, avant: avant, apres: neuf });
        /* La page ne doit jamais promettre une dose que le panier ne facture pas.
           ⚠ On échappe pour une VALEUR D'ATTRIBUT ENTRE GUILLEMETS (guillemet et antislash), PAS avec
             CSS.escape : celui-ci échappe pour un IDENTIFIANT, et appliqué ici il transformerait
             « Électrolytes (K · Mg · Na) » en « Électrolytes\ \(K… » qui ne correspondrait à rien. */
        var sel = '[data-mnl-affiche="' + String(nom).replace(/["\\]/g, '\\$&') + '"]';
        var cell = document.querySelector(sel);
        if (cell) cell.textContent = affiche(t, k, attendu);
      } catch (_) { /* une ligne illisible n'arrête pas les autres, et n'arrête surtout pas la vente */ }
    }
    etat.actif = true;
    if (etat.corrections.length) {
      try {
        console.warn(TAG + ' ' + etat.corrections.length + ' dose(s) recalculées depuis le cran : le Liquid de cette page' +
          ' n\'a pas été recuit après le dernier changement de grille. Lancer `node verif-porte19.mjs`.', etat.corrections);
      } catch (_) {}
    }
  }

  function demarrer() {
    var form;
    try { form = document.getElementById('mnl-fbuy-form'); } catch (_) { form = null; }
    if (!form) { etat.motifs.push('formulaire #mnl-fbuy-form absent (cette page n\'est pas une page formule)'); etat.actif = false; return; }
    etat.formulaire = true;
    try { auditer(form); } catch (e) {
      /* Ceinture : quoi qu'il arrive ici, le formulaire reste intact et soumettable. */
      etat.actif = false;
      etat.motifs.push('exception pendant l\'audit — abstention totale : ' + (e && e.message ? e.message : e));
    }
    /* Second passage AU MOMENT DE L'ENVOI, sans jamais interrompre celui-ci : pas de preventDefault,
       pas de valeur de retour, pas d'async. Le navigateur sérialise le formulaire APRÈS les écouteurs,
       donc une correction faite ici part bien avec la requête. Si ça lève, le navigateur poursuit
       l'envoi : une exception dans un écouteur `submit` n'annule pas la soumission. */
    try {
      form.addEventListener('submit', function () {
        try { auditer(form); } catch (_) {}
      });
    } catch (_) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();

  try {
    window.MNL_FBUY_DOSES = {
      etat: etat,
      rapport: function () {
        try {
          console.groupCollapsed(TAG + ' audit ' + etat.version + ' — ' +
            (etat.actif ? (etat.corrections.length ? etat.corrections.length + ' correction(s)' : 'conforme') : 'abstention'));
          console.log('signature du module :', etat.signature);
          console.log('lignes d\'actif lues :', etat.lignes);
          if (etat.motifs.length) console.log('motifs :', etat.motifs);
          if (etat.corrections.length) console.table(etat.corrections);
          console.groupEnd();
        } catch (_) {}
        return etat;
      }
    };
  } catch (_) {}
})();
